import { store } from '@/store'
import { isPast } from 'date-fns'

export default [
  {
    path: '/client/:id',
    name: 'client',
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(/* webpackChunkName: "profile" */ '@/components/clients/ClientProfile.vue'),
    beforeEnter: (to, from, next) => {
      guard(to, from, next);
    }
  }
]

const guard = async function(to, from, next) {
  if ( //checkIfTokenNeedsRefresh()
    window.localStorage.getItem('token') !== null &&
    window.localStorage.getItem('tokenExpiration') !== null &&
    isPast(new Date(JSON.parse(window.localStorage.getItem('tokenExpiration')) * 1000))
  ) {
    store.dispatch('refreshToken').then(() => next())
  }else{
    return next()
  }
}
